import React from "react";
import Service from '../../service/Service';
import * as actions from '../Actions';
const service = new Service();
 
export default function FaqsDisclaimer({eleRef}) {
    return (
        <div>
            <div className="duedate-btn-block" id="">
                <div className="duedate-question faqdiscl-title" id="faq" onClick={() => { actions.duDateQans("faq") }}>
                    <div id="faq" className="faqdiscl left B18_21">FAQs</div>
                    <span className="arrow-down icon downicon" data-icon-font="f" style={{display:"none"}}></span>
                    <span className="arrow-up icon upicon" data-icon-font="n" style={{display:"block"}}></span>
                </div>
                <div className="faq-dropdwn" style={{display:"block"}}>
                <div className="duedate-container">
                    <div className="duedate-faq" id="">
                        <div className="duedate-question" id="faq1" onClick={() => { actions.duDateQans("faq1") }}>
                            <h2 id="faq1">
                                <span className="M17_42" id="faq1">
                                    <span className="M17_9e" id="faq1">Q. </span>
                                    How is my due date calculated?
                                </span>
                            </h2>
                            <span className="arrow-down icon" data-icon-font="f"></span>
                            <span className="arrow-up icon" data-icon-font="n"></span>
                        </div>
                        <div className="duedate-answer">
                            <span className="R14_61">
                                <span className="R14_9e">A. </span>
                                Naegele's Rule is considered the gold standard of calculating the due date for a pregnancy. According to the rule, the expected date of delivery (EDD) is calculated by adding a year, subtracting three months, and adding seven days to the first day of a woman's last menstrual period (LMP).
                            </span>
                        </div>
                    </div>
                    <div className="duedate-faq" id="">
                        <div className="duedate-question" id="faq2" onClick={() => { actions.duDateQans("faq2") }}>
                            <h2 id="faq2">
                                <span className="M17_42" id="faq2">
                                    <span className="M17_9e" id="faq2">Q. </span>How accurate are these due dates?
                                </span>
                            </h2>
                            <span className="arrow-down icon" data-icon-font="f"></span>
                            <span className="arrow-up icon" data-icon-font="n"></span>
                        </div>
                        <div className="duedate-answer">
                            <span className="R14_61">
                                <span className="R14_9e">A. </span>No method can predict the due date of your baby with 100% certainty! Only Only about 5% of all babies are actually born on their estimated date of birth! This is mostly owing to the fact that a pregnancy can last anywhere between 38 and 42 weeks: so your baby may be born anywhere between 2 weeks before and 2 weeks after your estimated due date.
                            </span>
                        </div>
                    </div>
                    <div className="duedate-faq" id="">
                        <div className="duedate-question" id="faq3" onClick={() => { actions.duDateQans("faq3") }}>
                            <h2 id="faq3">
                                <span className="M17_42" id="faq3">
                                    <span className="M17_9e" id="faq3">Q. </span>
                                    When should I first see the doctor?
                                </span>
                            </h2>
                            <span className="arrow-down icon" data-icon-font="f"></span>
                            <span className="arrow-up icon" data-icon-font="n"></span>
                        </div>
                        <div className="duedate-answer">
                            <span className="R14_61">
                                <span className="R14_9e">A. </span>
                                Good prenatal care is strongly advised in ensuring a healthy pregnancy and baby. In other words, it’s never too early! Ideally you should consult a doctor before you start trying to get pregnant, and followup through your pregnancy till your baby is born. At the very latest, you should see your doctor as soon as that home pregnancy test kit tells you - you are pregnant!
                            </span>
                        </div>
                    </div>
                    <div className="duedate-faq" id="">
                        <div className="duedate-question" id="faq4" onClick={() => { actions.duDateQans("faq4") }}>
                            <h2 id="faq4">
                                <span className="M17_42" id="faq4">
                                    <span className="M17_9e" id="faq4">Q. </span>
                                    Can my due date change?
                                </span>
                            </h2>
                            <span className="arrow-down icon" data-icon-font="f"></span>
                            <span className="arrow-up icon" data-icon-font="n"></span>
                        </div>
                        <div className="duedate-answer">
                            <span className="R14_61">
                                <span className="R14_9e">A. </span>
                                There is a set formula used to calculate your estimated due date – any doctor using the same formula will give you the same EDD. However, when your baby actually arrives may be anywhere between 2 weeks before and after your EDD. Having said that, your doctor may recalibrate your EDD depending on how your pregnancy progresses.
                            </span>
                        </div>
                    </div>
                    <div className="duedate-faq" id="">
                        <div className="duedate-question" id="faq5" onClick={() => { actions.duDateQans("faq5") }}>
                            <h2 id="faq5">
                                <span className="M17_42" id="faq5">
                                    <span className="M17_9e" id="faq5">Q. </span>
                                    How else is my due date calculated?
                                </span>
                            </h2>
                            <span className="arrow-down icon" data-icon-font="f"></span>
                            <span className="arrow-up icon" data-icon-font="n"></span>
                        </div>
                        <div className="duedate-answer">
                            <span className="R14_61">
                                <span className="R14_9e">A. </span>
                                Apart from Naegele's Rule previously explained, the following methods can be used to estimate your date of conception and estimated due date: Size of your uterus: An early ultrasound (which your doctor may or may not recommend, depending on your particular case).Pregnancy milestones such as the first foetal heartbeat (usually seen at about 9 weeks of pregnancy), first time you feel foetal movement (roughly around 16 weeks), etc.  The fundal height: when the fundus reaches your navel, you are about 20 weeks into your pregnancy
                            </span>
                        </div>
                    </div>
                    <div className="duedate-faq" id="">
                        <div className="duedate-question" id="faq6" onClick={() => { actions.duDateQans("faq6") }}>
                            <h2 id="faq6">
                                <span className="M17_42" id="faq6">
                                    <span className="M17_9e" id="faq6">Q. </span>
                                    What are the other methods of calculating due dates?
                                </span>
                            </h2>
                            <span className="arrow-down icon" data-icon-font="f"></span>
                            <span className="arrow-up icon" data-icon-font="n"></span>
                        </div>
                        <div className="duedate-answer">
                            <span className="R14_61">
                                <span className="R14_9e">A. </span>Several other methods can be employed to calculate due date: An ultrasound scan.Clinical examination of pelvis (assessed alongside correct information about your menstrual cycle). Doppler ultrasonography (which can be used after 10 to 12 weeks of pregnancy). Human Chorionic Gonadotropin (hCG) Pregnancy Test.
                            </span>
                        </div>
                    </div>
                </div>
                <script type="application/ld+json" dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "FAQPage",
                        "mainEntity": [{
                            "@type": "Question",
                            "name": "Q. How is my due date calculated?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "A. Naegele's Rule is considered the gold standard of calculating the due date for a pregnancy. According to the rule, the expected date of delivery (EDD) is calculated by adding a year, subtracting three months, and adding seven days to the first day of a woman's last menstrual period (LMP)."
                            }
                        }, {
                            "@type": "Question",
                            "name": "Q. How accurate are these due dates?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "A. No method can predict the due date of your baby with 100% certainty! Only Only about 5% of all babies are actually born on their estimated date of birth! This is mostly owing to the fact that a pregnancy can last anywhere between 38 and 42 weeks: so your baby may be born anywhere between 2 weeks before and 2 weeks after your estimated due date."
                            }
                        }, {
                            "@type": "Question",
                            "name": "Q. When should I first see the doctor?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "A. Good prenatal care is strongly advised in ensuring a healthy pregnancy and baby. In other words, it’s never too early! Ideally you should consult a doctor before you start trying to get pregnant, and followup through your pregnancy till your baby is born. At the very latest, you should see your doctor as soon as that home pregnancy test kit tells you - you are pregnant!"
                            }
                        }, {
                            "@type": "Question",
                            "name": "Q. Can my due date change?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "A. There is a set formula used to calculate your estimated due date – any doctor using the same formula will give you the same EDD. However, when your baby actually arrives may be anywhere between 2 weeks before and after your EDD. Having said that, your doctor may recalibrate your EDD depending on how your pregnancy progresses."
                            }
                        }, {
                            "@type": "Question",
                            "name": "Q. How else is my due date calculated?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "A. Apart from Naegele's Rule previously explained, the following methods can be used to estimate your date of conception and estimated due date: Size of your uterus: An early ultrasound (which your doctor may or may not recommend, depending on your particular case).Pregnancy milestones such as the first foetal heartbeat (usually seen at about 9 weeks of pregnancy), first time you feel foetal movement (roughly around 16 weeks), etc. The fundal height: when the fundus reaches your navel, you are about 20 weeks into your pregnancy"
                            }
                        }]
                    })
                }}></script>
                </div>
            </div>
            <div className="duedate-btn-block" id="due_disclaimer">
                <div className="duedate-question faqdiscl-title" id="disc" onClick={() => { actions.duDateQans("disc") }}>
                    <div id="disc" className="faqdiscl left B18_21">Disclaimer</div>
                    <span className="arrow-down icon downicon" data-icon-font="f" style={{display:"none"}}></span>
                    <span className="arrow-up icon upicon" data-icon-font="n" style={{display:"block"}}></span>
                </div>
                <div className="faq-dropdwn" style={{display:"block"}}>
                    <div className="duedate-disclaimer">
                        <div className="disclaimer-title">
                            <h3>
                                <span className="M17_42">Disclaimer :</span>
                            </h3>
                        </div>
                        <div className="disclaimer-content">
                            <span className="R14_61"> Firstcry Parenting - Due Date Calculator determines the probable due date. Only your physician/Doctor can accurately determine your due date based on his/her knowledge of your medical history. All the calculations are tentative and Firstcry won’t be responsible for any related consequences.
                        </span>
                        </div>
                        <div className="disclaimer-title">
                            <h3>
                                <span className="M17_42">Reference :</span>
                            </h3>
                        </div>
                        <div className="disclaimer-content">
                            <span className="R14_61">
                                <a href="http://www.yourduedate.com/">
                                    http://www.yourduedate.com/
                                </a>
                                <a href="https://www.countdowntopregnancy.com/tools/due-date-calculator.php">
                                    https://www.countdowntopregnancy.com/tools/due-date-calculator.php
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// src/shared/tools/common/FaqsDisclaimer.js